import { STEAM_ITEM_IMAGE_URL } from '../constants/steam'

export const getSteamImageUrl = (marketHashName?: string) => {
  if (!marketHashName) return ''
  return `${STEAM_ITEM_IMAGE_URL}/${marketHashName}`
}
